import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import Colours from '../definitions/Colours';


function ProgressBar({ value, max = 100, ...otherProps }) {

    /* Pingu uses 0.33% as the default value if the value prop is 0,
        whereas with Glamazon we'd like to start at 5% */
    const minPercent = 5;

    // Add a minimum value to always display non-zero progress bar
    const percent = Math.min(100, Math.max(minPercent, value / max * 100));

    return (
        <ProgressBar.Container {...otherProps}>
            <ProgressBar.FilledBar
                percent={percent}
            />
        </ProgressBar.Container>
    );
}

ProgressBar.propTypes = {
    value: PropTypes.number.isRequired,
    max: PropTypes.number,
};


ProgressBar.Container = styled.div`
    position: relative;
    width: 100%;
    height: 10px;
    background-color: ${Colours.STONE_LIGHT};
`;

ProgressBar.FilledBar = styled.div`
    height: 100%;
    width: ${props => props.percent}%;
    background-color: ${Colours.BLUEBERRY};

    border-radius: ${props => props.percent === 100 ? '0' : '0 10px 10px 0'};
`;


export default ProgressBar;
